import { render, staticRenderFns } from "./ProductAddDialog.vue?vue&type=template&id=1aa058c1&scoped=true"
import script from "./ProductAddDialog.vue?vue&type=script&lang=js"
export * from "./ProductAddDialog.vue?vue&type=script&lang=js"
import style0 from "./ProductAddDialog.vue?vue&type=style&index=0&id=1aa058c1&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa058c1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aa058c1')) {
      api.createRecord('1aa058c1', component.options)
    } else {
      api.reload('1aa058c1', component.options)
    }
    module.hot.accept("./ProductAddDialog.vue?vue&type=template&id=1aa058c1&scoped=true", function () {
      api.rerender('1aa058c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialog/ProductAddDialog.vue"
export default component.exports